/** Iter 695 — sticky "Unfinished check-in" resume banner (founder:
 * "that should show as a notification till the transaction is done").
 * Amber #B45309, no ✕ — it only disappears once the session is paid,
 * cancelled or expired (endpoint returns active:null). */
import React from "react";
import { Link } from "react-router-dom";
import { useActiveEngagementSession } from "@/hooks/useActiveEngagementSession";

const fmt = (n) => `$${Number(n).toFixed(2)}`;

function subLine(a) {
  if (a.step === "pay") return a.to_pay != null ? `${fmt(a.to_pay)} to pay · Ready to pay` : "Ready to pay";
  if (a.step === "confirm")
    return a.to_pay != null ? `${fmt(a.to_pay)} to pay · Confirm your bill to pay` : "Confirm your bill to pay";
  if (a.step === "till") return "Waiting for the till to enter your bill";
  // photo
  return `${a.bill_amount != null ? `bill ${fmt(a.bill_amount)} · ` : ""}Add your photo to unlock the discount`;
}

/** @param skipQr hide when the banner's session belongs to the engage
 *  page already on screen (its panel shows the live session itself). */
export default function ActiveSessionBanner({ skipQr = null, className = "" }) {
  const q = useActiveEngagementSession();
  const a = q.data?.active;
  if (!a || (skipQr && a.qr_code_id === skipQr)) return null;
  return (
    <Link
      to={`/engage/${a.qr_code_id}?resume=${a.session_id}`}
      data-testid="active-session-banner"
      className={`block w-full min-h-[56px] rounded-2xl px-4 py-3 shadow-card transition-transform hover:scale-[1.005] ${className}`}
      style={{ backgroundColor: "#B45309" }}
    >
      <div className="flex items-center justify-between gap-3 text-white">
        <div className="min-w-0">
          <div className="text-sm font-black truncate" data-testid="active-session-banner-title">
            Unfinished check-in at {a.vendor_name}
          </div>
          <div className="text-xs font-semibold opacity-90 truncate" data-testid="active-session-banner-sub">
            {subLine(a)}
          </div>
        </div>
        <span className="shrink-0 text-sm font-black whitespace-nowrap">Resume ›</span>
      </div>
    </Link>
  );
}
